import { createStoreCreator } from 'lib/store'
import reducer from 'oee/locationDashboard/reducers'

export default createStoreCreator(reducer)
